import styled from "styled-components";

export const Image = styled.img`
    position: absolute;
    bottom: -1700px;
    z-index: 0;
`;
